<style lang="less">
.component{

}
</style>

<template>
	<!-- Main component -->
	<section class="component">

	</section>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		mounted: function () {
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_identity.vue